/**
 * rapid-cannon — 預設主武器「連發機砲」。
 *
 * ── 保真鐵則(最高風險,WEAPON_SYSTEM_SPEC §1 / §8)──
 *   這把武器 = **完全等價現有自動直射**。scene 的既有開火管線
 *   (`_handleAutoFire` 算間隔 → `_spawnBullet` 主彈 + 散彈 → `_spawnOneBullet`
 *   seed 彈跳/穿透/爆裂)維持原樣**完全不動**;rapid-cannon 的 tick 只是「呼叫
 *   scene 把那段原邏輯跑一次」的薄殼。
 *
 *   為什麼這樣設計:既有戰鬥測試直接呼叫 `_handleAutoFire` / `_spawnBullet`,
 *   且手感(間隔 × autoFireMult × synergyFireMult、散彈角度、彈跳/穿透 seed)
 *   全綁在那兩個方法。把邏輯搬出來改寫 = 高保真風險。改成「behavior 委派回原
 *   方法」→ 預設武器行為 byte-identical,回歸測試與手感零變動。ctx 用
 *   `runDefaultAutoFire()` seam 暴露這段(scene adapter 包既有 `_handleAutoFire`)。
 */

import type { WeaponBehavior, WeaponTickContext } from './types';

export const RAPID_CANNON_ID = 'rapid-cannon';

/** 一句話玩法說明(P2 之後 UI 用)。 */
export const RAPID_CANNON_BLURB = '對齊敵人那一排,持續自動連射(基本款,好上手)。';

/**
 * ctx 必須額外提供的 seam:跑一次 scene 既有的「固定間隔自動直射」邏輯。
 * scene adapter 把它接到 `_handleAutoFire(nowMs)`(原封不動的那條路徑)。
 */
export interface RapidCannonContext extends WeaponTickContext {
  /** 跑一次 scene 既有 auto-fire(含間隔判定 + 主彈 + 散彈 + 彈跳/穿透 seed)。 */
  runDefaultAutoFire: () => void;
}

export class RapidCannonBehavior implements WeaponBehavior {
  readonly id = RAPID_CANNON_ID;

  tick(ctx: WeaponTickContext): void {
    // 保真:直接委派回 scene 既有 auto-fire。若 ctx 沒帶 seam(理論上不會,
    // scene adapter 一定帶),退化為「不開火」而非 throw,確保 headless 安全。
    const c = ctx as Partial<RapidCannonContext>;
    if (typeof c.runDefaultAutoFire === 'function') {
      c.runDefaultAutoFire();
    }
  }

  reset(): void {
    // 間隔狀態(lastFireMs)由 scene 持有並在 create() 歸零,這裡無內部狀態。
  }
}
